import axios, { AxiosResponse } from "axios";
import { IAddress, IDispatcherAddress } from "../models/address";
import { ApiSearchResponse } from "../models/common";
import { ISearchParams, searchParamsInit } from "../models/searchParams";

export const addAddress = async (dto: IAddress): Promise<AxiosResponse<IDispatcherAddress>> => {
    return await axios.post("/dispatcher/address", dto);
};

export const changeAddress = async (dto: IAddress): Promise<AxiosResponse<IDispatcherAddress>> => {
    return await axios.patch("/dispatcher/address/change", dto);
};

export const deleteAddress = async (id: string): Promise<AxiosResponse<string>> => {
    return await axios.delete(`/dispatcher/address/${id}`);
};

export const getAddress = async (id: string): Promise<AxiosResponse<IDispatcherAddress>> => {
    return await axios.get(`/dispatcher/address/${id}`);
};

export const searchAddress = async (
    searchParams: ISearchParams = searchParamsInit,
): ApiSearchResponse<IDispatcherAddress> => {
    return await axios.post("/dispatcher/address/search", searchParams);
};
